export const sum = arr => arr.reduce((total, num) => total + num)